import { accountSchema } from '@juvare/contact-management/backend/features/accounts/shared';
import { classifierColumns, classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const badgeTemplateClassifierEntityName = 'badgeTemplateClassifier';
/**
 * Schema for Badge Template Classifier Data
 *
 * - `name` - The name of the badge template.
 * - `status` - The current status of the badge (e.g., active, inactive).
 * - `title` - The display title of the badge.
 * - `order` - The numeric order for how the badge appears in a sequence.
 * - `badgeTemplateFront` - The front design/template of the badge.
 * - `badgeTemplateBack` - The back design/template of the badge.
 * - `form` - Badge creation form configuration - what is displayed.
 * - `defaultFormSettings` - Badge creation form settings - what is preselected.
 * - `defaultSampleAccountData` - default sample account data - to be shown only on badge template preview, on for created badge.
 */
export const badgeTemplateClassifierSchema = classifierSchema.extend({
    title: z.string().max(255),
    order: z.number(),
    badgeTemplateFront: z.string(),
    badgeTemplateBack: z.string(),
    defaultFormSettings: z.any(),
    defaultSampleAccountData: accountSchema.optional(),
});
/**
 * Schema for Badge Template Classifier Columns
 */
export const badgeTemplateClassifierColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { title: {
        type: 'string-required',
    }, order: {
        type: 'number-required',
    } }));
